import {
  JADWALS_GET,
  JADWAL_JENJANGS_GET,
  JADWAL_YEARS_GET,
  JADWAL_SEMS_GET,
  JADWAL_KELASS_GET,
  JADWAL_PELAJARANS_GET,
  JADWAL_GURUS_GET,
  JADWAL_ADD,
  JADWAL_EDIT,
  JADWAL_GET,
  JADWAL_SETTING_EDIT,
  JADWAL_DELETE,
  JADWAL_SAVE_EVENTS,
  JADWAL_CLASH_TEACHERS,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';
import { uniqueVal } from '../../../../app/common/helpers/objectHelpers';

const initialState = {
  total: 0,
  search: {
    year: '',
    sem: '',
    jenjang: '',
    tingkat: '',
    kelas: '',
    pelajaran: '',
    published: 'all',
  },
  items: [],
  jadwalSetting: {},
  jenjangs: [],
  years: [],
  sems: [],
  kelass: [],
  pelajarans: [],
  gurus: [],
  events: [],
  clashTeachers: [],
  allPel: [],
  allGuru: [],
};

const jadwalsGet = (state, payload) => {
  const jadwals = payload.jadwals;
  return {
    ...state,
    total: jadwals.total,
    items: [...jadwals.items],
    search: { ...jadwals.search },
  };
};

const jadwalJenjangsGet = (state, payload) => {
  const jenjangs = payload.jenjangs;
  return {
    ...state,
    jenjangs: [...jenjangs],
  };
};

const jadwalYearsGet = (state, payload) => {
  const years = payload.years;
  return {
    ...state,
    years: [...years],
  };
};

const jadwalSemsGet = (state, payload) => {
  const sems = payload.sems;
  return {
    ...state,
    sems: [...sems],
  };
};

const jadwalKelassGet = (state, payload) => {
  const kelass = payload.kelass;
  return {
    ...state,
    kelass: [...kelass],
  };
};

const jadwalPelajaransGet = (state, payload) => {
  const pelajarans = payload.pelajarans;
  return {
    ...state,
    pelajarans: [...pelajarans],
  };
};

const jadwalGurusGet = (state, payload) => {
  const gurus = payload.gurus;
  return {
    ...state,
    gurus: [...gurus],
  };
};

const jadwalAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.jadwal.id + ''),
      payload.jadwal,
    ],
  };
};

const jadwalEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.jadwal.id + ''),
      payload.jadwal,
    ],
  };
};

const jadwalGet = (state, payload) => {
  let data = payload.jadwal;
  let jadwal = data.jadwal;
  let description = jadwal.description;
  let events = description && JSON.parse(description);
  let pelajarans = data.pelajarans;
  let gurus = data.gurus;
  let jenjangs = data.jenjangs;
  let kelass = data.kelass;
  let years = data.years;
  let sems = data.sems;
  let jadwalSetting = data.jadwalSetting;

  let newEvents = [];
  let customPelajarans = [];
  let customGurus = [];
  for (let j = 0; j < events?.length; j++) {
    let event = events[j];
    newEvents = [...newEvents, { ...event, noEvent: j + 1 }];

    if (!(event.senActivity === '' || event.senActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.senActivity];
    }
    if (!(event.senGuru === '' || event.senGuru === undefined)) {
      customGurus = [...customGurus, event.senGuru];
    }
    if (!(event.selActivity === '' || event.selActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.selActivity];
    }
    if (!(event.selGuru === '' || event.selGuru === undefined)) {
      customGurus = [...customGurus, event.selGuru];
    }
    if (!(event.rabActivity === '' || event.rabActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.rabActivity];
    }
    if (!(event.rabGuru === '' || event.rabGuru === undefined)) {
      customGurus = [...customGurus, event.rabGuru];
    }
    if (!(event.kamActivity === '' || event.kamActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.kamActivity];
    }
    if (!(event.kamGuru === '' || event.kamGuru === undefined)) {
      customGurus = [...customGurus, event.kamGuru];
    }
    if (!(event.jumActivity === '' || event.jumActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.jumActivity];
    }
    if (!(event.jumGuru === '' || event.jumGuru === undefined)) {
      customGurus = [...customGurus, event.jumGuru];
    }
    if (!(event.sabActivity === '' || event.sabActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.sabActivity];
    }
    if (!(event.sabGuru === '' || event.sabGuru === undefined)) {
      customGurus = [...customGurus, event.sabGuru];
    }
    if (!(event.minActivity === '' || event.minActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.minActivity];
    }
    if (!(event.minGuru === '' || event.minGuru === undefined)) {
      customGurus = [...customGurus, event.minGuru];
    }
  }

  let uniqueCustomPelajarans = customPelajarans.filter(uniqueVal);
  let uniqueCustomGurus = customGurus.filter(uniqueVal);

  let allPel = [];
  pelajarans &&
    pelajarans[0] &&
    pelajarans.forEach((p) => {
      allPel = [...allPel, p.code];
    });

  if (uniqueCustomPelajarans && uniqueCustomPelajarans[0]) {
    allPel = [...allPel, ...uniqueCustomPelajarans];
  }

  let allActivities = [];
  const activivites = state.jadwalSetting && state.jadwalSetting.activities;
  activivites &&
    activivites[0] &&
    activivites.forEach((a) => {
      allActivities = [...allActivities, a.name];
    });

  if (allActivities && allActivities[0]) {
    allPel = [...allPel, ...allActivities];
  }

  let allGuru = [];
  gurus &&
    gurus[0] &&
    gurus.forEach((g) => {
      allGuru = [...allGuru, g.code];
    });

  if (uniqueCustomGurus && uniqueCustomGurus[0]) {
    allGuru = [...allGuru, ...uniqueCustomGurus];
  }

  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.jadwal.id + ''),
      payload.jadwal,
    ],
    events: newEvents,
    allPel,
    allGuru,
    jenjangs: jenjangs ? jenjangs : state.jenjangs,
    kelass: kelass ? kelass : state.kelass,
    years: years ? years : state.years,
    sems: sems ? sems : state.sems,
    jadwalSetting: jadwalSetting ? jadwalSetting : state.jadwalSetting,
  };
};

const jadwalSettingEdit = (state, payload) => {
  const item = payload.jadwalSetting;

  const jadwalSetting = item?.description && JSON.parse(item.description);
  return {
    ...state,
    jadwalSetting: jadwalSetting ? jadwalSetting : state.jadwalSetting,
  };
};

const jadwalSaveEvents = (state, payload) => {
  const events = payload.events;

  let newEvents = [];
  let customPelajarans = [];
  let customGurus = [];
  for (let j = 0; j < events?.length; j++) {
    let event = events[j];
    newEvents = [...newEvents, { ...event, noEvent: j + 1 }];

    if (!(event.senActivity === '' || event.senActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.senActivity];
    }
    if (!(event.senGuru === '' || event.senGuru === undefined)) {
      customGurus = [...customGurus, event.senGuru];
    }
    if (!(event.selActivity === '' || event.selActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.selActivity];
    }
    if (!(event.selGuru === '' || event.selGuru === undefined)) {
      customGurus = [...customGurus, event.selGuru];
    }
    if (!(event.rabActivity === '' || event.rabActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.rabActivity];
    }
    if (!(event.rabGuru === '' || event.rabGuru === undefined)) {
      customGurus = [...customGurus, event.rabGuru];
    }
    if (!(event.kamActivity === '' || event.kamActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.kamActivity];
    }
    if (!(event.kamGuru === '' || event.kamGuru === undefined)) {
      customGurus = [...customGurus, event.kamGuru];
    }
    if (!(event.jumActivity === '' || event.jumActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.jumActivity];
    }
    if (!(event.jumGuru === '' || event.jumGuru === undefined)) {
      customGurus = [...customGurus, event.jumGuru];
    }
    if (!(event.sabActivity === '' || event.sabActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.sabActivity];
    }
    if (!(event.sabGuru === '' || event.sabGuru === undefined)) {
      customGurus = [...customGurus, event.sabGuru];
    }
    if (!(event.minActivity === '' || event.minActivity === undefined)) {
      customPelajarans = [...customPelajarans, event.minActivity];
    }
    if (!(event.minGuru === '' || event.minGuru === undefined)) {
      customGurus = [...customGurus, event.minGuru];
    }
  }

  let uniqueCustomPelajarans = customPelajarans.filter(uniqueVal);
  let uniqueCustomGurus = customGurus.filter(uniqueVal);

  let allPel = [];
  let pelajarans = state.pelajarans;
  pelajarans &&
    pelajarans[0] &&
    pelajarans.forEach((p) => {
      allPel = [...allPel, p.code];
    });

  if (uniqueCustomPelajarans && uniqueCustomPelajarans[0]) {
    allPel = [...allPel, ...uniqueCustomPelajarans];
  }

  let allActivities = [];
  const activivites = state.jadwalSetting && state.jadwalSetting.activities;
  activivites &&
    activivites[0] &&
    activivites.forEach((a) => {
      allActivities = [...allActivities, a.name];
    });

  if (allActivities && allActivities[0]) {
    allPel = [...allPel, ...allActivities];
  }

  let allGuru = [];
  let gurus = state.gurus;
  gurus &&
    gurus[0] &&
    gurus.forEach((g) => {
      allGuru = [...allGuru, g.code];
    });

  if (uniqueCustomGurus && uniqueCustomGurus[0]) {
    allGuru = [...allGuru, ...uniqueCustomGurus];
  }

  return {
    ...state,
    events: newEvents,
    allPel,
    allGuru,
  };
};

const jadwalClashTeachers = (state, payload) => {
  const clashTeachers = payload.clashTeachers;

  return {
    ...state,
    clashTeachers,
  };
};

const jadwalDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [...state.items.filter((i) => i.id + '' !== payload.jadwal.id + '')],
  };
};

export default createReducer(initialState, {
  [JADWALS_GET]: jadwalsGet,
  [JADWAL_JENJANGS_GET]: jadwalJenjangsGet,
  [JADWAL_YEARS_GET]: jadwalYearsGet,
  [JADWAL_SEMS_GET]: jadwalSemsGet,
  [JADWAL_KELASS_GET]: jadwalKelassGet,
  [JADWAL_PELAJARANS_GET]: jadwalPelajaransGet,
  [JADWAL_GURUS_GET]: jadwalGurusGet,
  [JADWAL_ADD]: jadwalAdd,
  [JADWAL_EDIT]: jadwalEdit,
  [JADWAL_GET]: jadwalGet,
  [JADWAL_SETTING_EDIT]: jadwalSettingEdit,
  [JADWAL_SAVE_EVENTS]: jadwalSaveEvents,
  [JADWAL_CLASH_TEACHERS]: jadwalClashTeachers,
  [JADWAL_DELETE]: jadwalDelete,
});
